export default {
    ebike: 100,
    adultBike: 50,
    kidsBike: 35,
    trailer: 30,
    childSeat: 20,
    tagalong: 45,
    panniers: 10,
}
